import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { _T, C } from '../shared/theme';
import { s_PB, s_GC } from '../shared/styles';
import { CLAUDE_HEADERS } from '../shared/api';
import { GROWTH_CATEGORIES } from '../features/goals/constants';
import Confetti from '../components/ui/Confetti';

function LevelUpModal({lang, category, newLevel, onClose}) {
  const nl = lang==="nl";
  const [aiMsg, setAiMsg] = useState(null);
  const levelDef = category.levels[newLevel-1];

  useEffect(()=>{
    const fetch_ = async()=>{
      try{
        const res=await fetch("https://api.anthropic.com/v1/messages",{method:"POST",headers:CLAUDE_HEADERS,body:JSON.stringify({model:"claude-haiku-4-5-20251001",max_tokens:100,system:"Je bent een warme wellness coach. Max 30 woorden. Motiverend en persoonlijk.",messages:[{role:"user",content:`Iemand heeft level ${newLevel} bereikt in ${nl?category.label:category.labelEN}. Geef een kort motiverend bericht in het ${nl?"Nederlands":"Engels"}.`}]})});
        const d=await res.json();setAiMsg(d.content?.[0]?.text||null);
      }catch{setAiMsg(null);}
    };
    fetch_();
  },[]);

  return ReactDOM.createPortal(
    <>
      <Confetti/>
      <div style={{position:"fixed",inset:0,zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:24,background:"rgba(0,0,0,0.75)"}}>
        <div className="popIn" style={{background:_T.bg2,border:`2px solid ${category.color}`,borderRadius:28,padding:28,maxWidth:340,width:"100%",textAlign:"center",position:"relative"}}>
          <button onClick={onClose} style={{position:"absolute",top:12,right:12,background:"transparent",border:"none",color:C.silver,fontSize:20,cursor:"pointer",padding:4,lineHeight:1}}>✕</button>
          <div style={{fontSize:52,marginBottom:8}}>{category.icon}</div>
          <div style={{fontSize:11,color:category.color,letterSpacing:3,fontWeight:700,marginBottom:6}}>
            {nl?"LEVEL UP!":"LEVEL UP!"}
          </div>
          <div style={{fontFamily:"Georgia,serif",fontSize:22,color:C.white,marginBottom:4}}>
            {nl?category.label:category.labelEN}
          </div>
          <div style={{fontSize:36,fontWeight:700,color:category.color,marginBottom:12}}>
            Level {newLevel}
          </div>
          <div style={{...s_GC({padding:"12px 16px",marginBottom:14,textAlign:"left"})}}>
            <div style={{fontSize:9,color:_T.accent,letterSpacing:3,fontWeight:600,marginBottom:4}}>{nl?"NIEUW DOEL":"NEW GOAL"}</div>
            <div style={{color:C.white,fontSize:13,fontWeight:600,marginBottom:2}}>{nl?levelDef.goal:levelDef.goalEN}</div>
            <div style={{color:C.silver,fontSize:12}}>{nl?levelDef.exercise:levelDef.exerciseEN} · {levelDef.duration}</div>
          </div>
          {aiMsg && (
            <div style={{...s_GC({padding:"12px 16px",marginBottom:14})}}>
              <div style={{fontSize:13,color:C.silver2,fontStyle:"italic",lineHeight:1.6}}>🦋 "{aiMsg}"</div>
            </div>
          )}
          <div style={{display:"flex",alignItems:"center",gap:8,justifyContent:"center",marginBottom:16}}>
            <div style={{background:`${category.color}20`,border:`1px solid ${category.color}44`,borderRadius:20,padding:"6px 14px",fontSize:12,color:category.color,fontWeight:600}}>
              🏅 {nl?"Badge verdiend!":"Badge earned!"}
            </div>
            <div style={{background:`${C.teal}20`,border:`1px solid ${C.teal}44`,borderRadius:20,padding:"6px 14px",fontSize:12,color:C.teal,fontWeight:600}}>
              🔓 {nl?"Nieuwe oefeningen":"New exercises"}
            </div>
          </div>
          <button style={s_PB({width:"100%",fontSize:15})} onClick={onClose}>
            {nl?"Doorgaan →":"Continue →"}
          </button>
        </div>
      </div>
    </>,
    document.body
  );
}

export default LevelUpModal;
